import css from "./User.css";
import Modal from "react-modal";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import isEqual from "lodash/isEqual";
import addicon from "../../images/icons/addicon.svg";
import BankAccountVerification from "./elements/Bank";
import InviteIcon from "../../images/icons/invite.svg";
import { useUserProfiles, useWiseBanks, fetchTeams, useUserPendingInvitesCount } from "./userProfileQueries";
import { useSelector, useDispatch } from "react-redux";
import UserIcon from "../../images/icons/user-icon.svg";
import { RenderUserCTA } from "../../helpers/invoiceHelpers";
import profile_image from "../../images/user/Default_pfp.png";
import dletImage from "../../images/singleinvoice/delete.svg";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import Plus from "../../images/icons/plus-black.svg";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { setNotification } from "../../features/notification/notificationSlice.js";
import userCategory from "../../constants/userCategory";
import userTypeName from "../../constants/userType";
import DownloadImage from "../../images/icons/download-icon.svg";
import { motion } from "framer-motion";
import moment from "moment-timezone";
import { useContractTypes, useUserType } from "./UserDetails/UserProfile/useUserView.jsx";
import TruncateFilterFieldView from "../helpers/truncateFilterFieldView.js";
import { RotatingLines } from "react-loader-spinner";
import { setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import { handleResendEmailsService } from "./services.js";
import InviteUser from "./Includes/InviteUser.jsx";
import ResentInvitations from "./Includes/ResentInvitations.jsx";
import Filters from "./Includes/Filters.jsx";
import RecentUsers from "./Includes/RecentUsers.jsx";
import { handleSubmitService } from "./services.js";

// Utility function to validate file (preserving original logic structure)
const validateFile = (file) => {
  const maxFileSize = 5 * 1024 * 1024;
  if (!file) return { valid: false, message: "Please select a file." };
  if (file.size > maxFileSize) return { valid: false, message: "File size exceeds the 5 MB limit." };
  if (file.name.split(".").pop() !== "xlsx") return { valid: false, message: "Only xlsx files are supported." };
  return { valid: true };
};

// Custom component to render member name (unchanged)
const UseRenderMemberName = ({ rowData }) => {
  const [showFullname, setShowFullname] = useState(false);

  const fullName = rowData.first_name
    ? `${rowData.first_name} ${rowData.last_name || ""}`.trim()
    : rowData.company_first_name
      ? `${rowData.company_first_name} ${rowData.company_last_name || ""}`.trim()
      : `${rowData.company_name} (Company)`;

  const displayName = showFullname
    ? fullName
    : fullName && fullName.length <= 21
      ? fullName
      : fullName && fullName.slice(0, 21) + "...";

  return (
    <div
      className={`member-name${showFullname ? " active" : ""}`}
      onMouseEnter={() => {
        if (fullName.length > 21) {
          setShowFullname(true);
        }
      }}
      onMouseLeave={() => setShowFullname(false)}
    >
      {rowData.profile_image !== null && rowData.profile_image !== "null" ? (
        <img
          src={`/uploads/lowProfileImage/${rowData.profile_image}`}
          alt={fullName}
          className="member-image"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/uploads/lowProfileImage/user_default.png";
          }}
        />
      ) : (
        <img src={profile_image} alt={fullName} className="member-image" />
      )}
      <span>{displayName}</span>
    </div>
  );
};

// Error boundary component (unchanged)
function ErrorBoundary({ error }) {
  return (
    <div style={{ color: "red", padding: "2rem", textAlign: "center" }}>
      <h2>Something went wrong.</h2>
      <pre>{error?.toString()}</pre>
    </div>
  );
}

const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [filter, setFilter] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [users, setUsers] = useState([]);
  const [first, setFirst] = useState(0);
  const [emails, setEmails] = useState([]);
  const [userType, setUserType] = useState("");
  const roleDropdownRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMailLoading, setIsMailLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [roleDropdownOpen, setRoleDropdownOpen] = useState(false);
  const userTypeDropdownRef = useRef(null);
  const [bulkImportFile, setBulkImportFile] = useState(null);
  const [isResendModalOpen, setIsResendModalOpen] = useState(false);
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [userFilter, setUserFilter] = useState("All");
  const [selectAllTeam, setSelectAllTeam] = useState(true);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [isTeamDropdownOpen, setIsTeamDropdownOpen] = useState(false);
  const [isTeamModalDropdownOpen, setIsTeamModalDropdownOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [userCategoryFilter, setUserCategoryFilter] = useState("All");
  const [selectAllCategory, setSelectAllCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [isCategoryModalDropdownOpen, setIsCategoryModalDropdownOpen] = useState(false);
  const [userCategorySearchTerm, setUserCategorySearchTerm] = useState("");
  const [accountTypeFilter, setAccountTypeFilter] = useState("All");
  const [selectAllAccountType, setSelectAllAccountType] = useState(true);
  const [selectedAccountType, setSelectedAccountType] = useState([]);
  const [isAccountTypeDropdownOpen, setIsAccountTypeDropdownOpen] = useState(false);
  const [isAccountTypeModalDropdownOpen, setIsAccountTypeModalDropdownOpen] = useState(false);
  const [roleIdSearchTerm, setRoleIdSearchTerm] = useState("");
  const [statusModalDropdownOpen, setStatusModalDropdownOpen] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isBulkImportLoading, setIsBulkImportLoading] = useState(false);
  const [userTypeDropdownOpen, setUserTypeDropdownOpen] = useState(false);
  const [bulkImportFileName, setBulkImportFileName] = useState("");
  const [isBulkImportModalOpen, setIsBulkImportModalOpen] = useState(false);
  const [alreadySentEmailsList, setAlreadySentEmailsList] = useState([]);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const teamDropdownRef = useRef(null);
  const teamModalDropdownRef = useRef(null);
  const userCategoryDropdownRef = useRef(null);
  const userCategoryModalDropdownRef = useRef(null);
  const accountTypeDropdownRef = useRef(null);
  const accountTypeModalDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const statusModalDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const [paginatedTeams, setPaginatedTeams] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allTeam, setAllTeam] = useState([]);
  const [teamsLoading, setTeamsLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [componentError, setComponentError] = useState(null);
  let token = null;
  const { user } = useSelector((state) => state.auth);
  const { appSettings } = useSelector((state) => state.appSettings);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  useEffect(() => {
    dispatch(setHeaderText("My Team"));
  }, []);

  const { data: userProfiles = [], refetch: refetchUserProfiles, isLoading: userProfileLoading, isError, error } = useUserProfiles(token);
  const { data: roleId = [], isLoading: roleLoading } = useUserType(token);
  const { data: userPendingInvitesCount = 0, isLoading: pendingInvitesCountLoading, refetch: refetchPendingInvitesCount } = useUserPendingInvitesCount(token);

  const getAllTeams = async () => {
    try {
      setIsUpdating(true);
      await dispatch(setAppLoading(true));
      const allTeam = await fetchTeams(
        token,
        currentPage,
        rowsPerPage,
        filter,
        selectedTeams,
        selectedCategory,
        selectedAccountType,
        selectedStatus
      );
      setTeams(allTeam);
      setPaginatedTeams(allTeam.users);
      setTotal(allTeam.total);
    } catch (error) {
      setComponentError(error);
      toast.error("Failed to fetch teams. Please try again.", {
        position: "bottom-right",
        autoClose: 3000,
      });
      console.error(error);
    } finally {
      setIsUpdating(false);
      await dispatch(setAppLoading(false));
    }
  };

  useEffect(() => {
    const handleLoading = async () => {
      await dispatch(setAppLoading(isUpdating));
    };
    handleLoading();
  }, [isUpdating]);

  useEffect(() => {
    const handler = setTimeout(async () => {
      try {
        await Promise.all([
          setFilter(debouncedValue),
        ]);
      } catch (error) {
        console.error("Error in async operations:", error);
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [debouncedValue]);

  const memoizedDependencies = useMemo(() => {
    return {
      selectedTeams,
      selectedAccountType,
      selectedCategory,
      selectedStatus,
      currentPage,
      rowsPerPage,
    };
  }, [selectedTeams, selectedAccountType, selectedCategory, selectedStatus, currentPage, rowsPerPage]);

  useEffect(() => {
    if (
      memoizedDependencies.selectedTeams.length > 0 &&
      memoizedDependencies.selectedAccountType.length > 0 &&
      memoizedDependencies.selectedCategory.length > 0
    ) {
      getAllTeams();
    }
  }, [
    memoizedDependencies.selectedTeams,
    memoizedDependencies.selectedAccountType,
    memoizedDependencies.selectedCategory,
    memoizedDependencies.selectedStatus,
    memoizedDependencies.currentPage,
    memoizedDependencies.rowsPerPage,
    filter,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedTeams]);

  useEffect(() => {
    let isMounted = true;
    const fetchAllTeams = async () => {
      try {
        const response = await fetchTeams(
          token,
          currentPage,
          rowsPerPage,
          filter,
          selectedTeams,
          selectedCategory,
          selectedAccountType,
          selectedStatus
        );
        if (isMounted) {
          setAllTeam(response);
          setTeamsLoading(false);
        }
      } catch (error) {
        setComponentError(error);
        toast.error("Failed to fetch all teams.", {
          position: "bottom-right",
          autoClose: 3000,
        });
        console.error(error);
      }
    };
    const fetchData = async () => {
      await Promise.all([fetchAllTeams()]);
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [paginatedTeams]);

  useEffect(() => {
    const updateSelectedTeams = async () => {
      await Promise.all([
        new Promise((resolve) => {
          setSelectedTeams(userProfiles.map((team) => team._id));
          resolve();
        }),
      ]);
    };
    updateSelectedTeams();
  }, [userProfiles]);

  useEffect(() => {
    const updateSelectedAccountType = async () => {
      await Promise.all([
        new Promise((resolve) => {
          setSelectedAccountType(roleId.map((team) => team._id));
          resolve();
        }),
      ]);
    };
    updateSelectedAccountType();
  }, [roleId]);

  useEffect(() => {
    const updateSelectedCategory = async () => {
      await Promise.all([
        new Promise((resolve) => {
          setSelectedCategory(userCategoryList.map((item) => item.value));
          resolve();
        }),
      ]);
    };
    updateSelectedCategory();
  }, []);

  useEffect(() => {
    const updateIsUpdating = async () => {
      await Promise.all([
        new Promise((resolve) => {
          setIsUpdating(true);
          resolve();
        }),
      ]);
    };
    updateIsUpdating();
  }, [userProfileLoading]);

  const {
    data: typeContract = [],
    isLoading: contractTypesLoading,
    isError: contractTypesError,
  } = useContractTypes();

  const {
    data: wiseBanks = [],
    refetch: refetchWiseBanks,
    isLoading: wiseBanksLoading,
    isError: wiseBanksError,
    error: wiseBanksErrorMessage,
  } = useWiseBanks(token);

  useEffect(() => {
    if (userProfiles) {
      setUsers(userProfiles);
    }
  }, [userProfiles]);

  const renderUserStatus = (rowData) => {
    let statusClass;
    let statusName;
    if (rowData.is_active === true) {
      statusClass = "active";
      statusName = "Active";
    } else if (rowData.is_active === false) {
      statusClass = "inactive";
      statusName = "Inactive";
    }
    return (
      <span className={`payment-status ${statusClass}`}>{statusName}</span>
    );
  };
  const [emailValidation, setEmailValodation] = useState(false);
  const [selectValidation, setSelectValodation] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleSubmitService(handleOpenResendModal, dispatch, setNotification, setAlreadySentEmailsList, setIsModalOpen, email, userType, emails, setEmail, setEmails, setEmailValodation, setSelectValodation, toast, handleCloseModal, refetchPendingInvitesCount, setIsMailLoading, setComponentError, token);
  };

  const handleResendEmails = async () => {
    await handleResendEmailsService(alreadySentEmailsList, token, setIsMailLoading, setIsResendModalOpen, toast, global, refetchPendingInvitesCount, handleCloseResendModal, setComponentError);
  };

  const handleAddEmail = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmails = emailRegex.test(email);
    if (email && !isValidEmails) {
      toast.error("Please enter valid email addresses!!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    const newEmailEntry = { email: email, id: Date.now(), userType: userType };
    setEmails([...emails, newEmailEntry]);
    setEmail("");
    setUserType("");
  };

  const handleToggleRoleDropdown = () => {
    setRoleDropdownOpen(!roleDropdownOpen);
  };

  const handleToggleUserTypeDropdown = () => {
    setUserTypeDropdownOpen(!userTypeDropdownOpen);
  };

  const handleUserTypeOptionClick = (selectedValue) => {
    setUserType(selectedValue);
    setSelectValodation(false);
    setUserTypeDropdownOpen(false);
  };

  const handleCheckboxTeamChange = (teamId) => {
    const updatedSelection = [...selectedTeams];
    const index = updatedSelection.indexOf(teamId);

    if (index === -1) {
      updatedSelection.push(teamId);
    } else {
      updatedSelection.splice(index, 1);
    }
    setFirst(0);
    setSelectedTeams(updatedSelection);
  };

  const handleSelectAllTeamChange = () => {
    if (!selectAllTeam) {
      setSelectedTeams(userProfiles.map((team) => team._id));
    } else {
      setSelectedTeams([]);
    }
    setSelectAllTeam(!selectAllTeam);
  };

  const filteredUsers = userProfiles.filter((user) => {
    const fullName = user.first_name
      ? `${user.first_name} ${user.middle_name || ""} ${user.last_name}`
      : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
    return fullName.toLowerCase().includes(userSearchTerm.toLowerCase());
  });

  const handleUserSearchChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  const toggleTeamDropdown = () => {
    setIsTeamDropdownOpen(!isTeamDropdownOpen);
    setUserSearchTerm("");
  };

  const toggleTeamModalDropdown = () => {
    setIsTeamModalDropdownOpen(!isTeamModalDropdownOpen);
    setUserSearchTerm("");
  };

  const userCategoryList = Object.entries(userCategory)
    .filter(([name]) => name === "Individual" || name === "Business")
    .map(([name, value]) => ({
      name,
      value,
    }));

  const filteredUserCategoryList = userCategoryList && userCategoryList.filter((userCategory) =>
    userCategory && userCategory.name
      ?.toLowerCase()
      .includes(userCategorySearchTerm?.toLowerCase())
  );

  const handleUserCategorySearchChange = (e) => {
    setUserCategorySearchTerm(e.target.value);
  };

  const toggleCategoryDropdown = () => {
    setUserCategorySearchTerm("");
    setIsCategoryDropdownOpen(!isCategoryDropdownOpen);
  };

  const toggleCategoryModalDropdown = () => {
    setUserCategorySearchTerm("");
    setIsCategoryModalDropdownOpen(!isCategoryModalDropdownOpen);
  };

  const handleCheckboxCategoryChange = (value) => {
    setSelectedCategory((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value)
        : [...prevSelected, value]
    );
  };

  const handleSelectAllCategoryChange = () => {
    setSelectAllCategory(!selectAllCategory);
    if (!selectAllCategory) {
      setSelectedCategory(userCategoryList.map((item) => item.value));
    } else {
      setSelectedCategory([]);
    }
  };

  useEffect(() => {
    const updateCategorySelection = async () => {
      await Promise.all([
        new Promise((resolve) => {
          setSelectAllCategory(selectedCategory.length === userCategoryList.length);
          resolve();
        }),
        new Promise((resolve) => {
          if (selectedCategory.length === userCategoryList.length) {
            setUserCategoryFilter("All");
          } else {
            setUserCategoryFilter(selectedTeams);
          }
          resolve();
        }),
      ]);
    };

    updateCategorySelection();
  }, [selectedCategory, userCategoryList]);

  const filteredRoleId = roleId.filter(
    (role) =>
      !(
        user.role_id === userTypeName.Admin &&
        role._id === userTypeName.Super_Admin
      )
  );
  const filteredRoleIdList = filteredRoleId && filteredRoleId.filter((accountType) =>
    accountType && accountType.user_type
      ?.toLowerCase()
      .includes(roleIdSearchTerm?.toLowerCase())
  );

  const handleRoleIdSearchChange = (e) => {
    setRoleIdSearchTerm(e.target.value);
  };

  const toggleAccountTypeDropdown = () => {
    setIsAccountTypeDropdownOpen(!isAccountTypeDropdownOpen);
  };

  const toggleAccountTypeModalDropdown = () => {
    setIsAccountTypeModalDropdownOpen(!isAccountTypeModalDropdownOpen);
  };

  const handleCheckboxAccountTypeChange = (value) => {
    const updatedSelection = [...selectedAccountType];
    const index = updatedSelection.indexOf(value);

    if (index === -1) {
      updatedSelection.push(value);
    } else {
      updatedSelection.splice(index, 1);
    }
    setSelectedAccountType(updatedSelection);
  };

  const handleSelectAllAccountTypeChange = () => {
    setSelectAllAccountType(!selectAllAccountType);
    if (!selectAllAccountType) {
      setSelectedAccountType(filteredRoleId.map((item) => item._id));
    } else {
      setSelectedAccountType([]);
    }
  };

  const toggleStatusDropdown = () => {
    setStatusDropdownOpen(!statusDropdownOpen);
  };

  const toggleStatusModalDropdown = () => {
    setStatusModalDropdownOpen(!statusModalDropdownOpen);
  };

  const selectStatusOption = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
    setStatusDropdownOpen(false);
  };

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const clearFilters = () => {
    setSelectedTeams(userProfiles.map((team) => team._id));
    setSelectedCategory(userCategoryList.map((item) => item.value));
    setSelectedAccountType(filteredRoleId.map((type) => type._id));
    setShowFilterModal(false);
  };

  const checkAndShowConfirmationModal = () => {
    const isTeamsModified = !isEqual(
      selectedTeams,
      userProfiles.map((team) => team._id)
    );
    const isUserCategoryModified = !isEqual(
      selectedStatus,
      userCategoryList.map((item) => item.value)
    );
    const isAccountTypeModified = !isEqual(
      selectedAccountType,
      filteredRoleId.map((type) => type._id)
    );

    if (isTeamsModified || isUserCategoryModified || isAccountTypeModified) {
      setShowConfirmationModal(true);
    } else {
      setShowFilterModal(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const handleApplyConfirm = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const toggleFilterModal = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(!showFilterModal);
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideRoleDropdown =
      roleDropdownRef.current && roleDropdownRef.current.contains(event.target);
    const isClickInsideUserTypeDropdown =
      userTypeDropdownRef.current &&
      userTypeDropdownRef.current.contains(event.target);
    const isClickInsideTeamDropdown =
      teamDropdownRef.current && teamDropdownRef.current.contains(event.target);
    const isClickInsideTeamModalDropdown =
      teamModalDropdownRef.current &&
      teamModalDropdownRef.current.contains(event.target);
    const isClickInsideUserCategoryDropdown =
      userCategoryDropdownRef.current &&
      userCategoryDropdownRef.current.contains(event.target);
    const isClickInsideUserCategoryModalDropdown =
      userCategoryModalDropdownRef.current &&
      userCategoryModalDropdownRef.current.contains(event.target);
    const isClickInsideAccountTypeDropdown =
      accountTypeDropdownRef.current &&
      accountTypeDropdownRef.current.contains(event.target);
    const isClickInsideAccountTypeModalDropdown =
      accountTypeModalDropdownRef.current &&
      accountTypeModalDropdownRef.current.contains(event.target);
    const isClickInsideStatusDropdown =
      statusDropdownRef.current &&
      statusDropdownRef.current.contains(event.target);
    const isClickInsideStatusModalDropdown =
      statusModalDropdownRef.current &&
      statusModalDropdownRef.current.contains(event.target);
    const isClickInsideshowingDropdown =
      showingDropdownRef.current && showingDropdownRef.current.contains(event.target);

    if (!isClickInsideRoleDropdown) {
      setRoleDropdownOpen(false);
    }
    if (!isClickInsideUserTypeDropdown) {
      setUserTypeDropdownOpen(false);
    }
    if (!isClickInsideTeamDropdown) {
      setIsTeamDropdownOpen(false);
    }
    if (!isClickInsideTeamModalDropdown) {
      setIsTeamModalDropdownOpen(false);
    }
    if (!isClickInsideUserCategoryDropdown) {
      setIsCategoryDropdownOpen(false);
    }
    if (!isClickInsideUserCategoryModalDropdown) {
      setIsCategoryModalDropdownOpen(false);
    }
    if (!isClickInsideAccountTypeDropdown) {
      setIsAccountTypeDropdownOpen(false);
    }
    if (!isClickInsideAccountTypeModalDropdown) {
      setIsAccountTypeModalDropdownOpen(false);
    }
    if (!isClickInsideStatusDropdown) {
      setStatusDropdownOpen(false);
    }
    if (!isClickInsideStatusModalDropdown) {
      setStatusModalDropdownOpen(false);
    }
    if (!isClickInsideshowingDropdown) {
      setShowingDropdownOpen(false);
    }
  };

  useEffect(() => {
    const handleAsyncClickOutsideDropdown = async (event) => {
      try {
        await Promise.all([
          new Promise((resolve) => {
            handleClickOutsideDropdown(event);
            resolve();
          }),
        ]);
      } catch (error) {
        console.error("Error handling click outside", error);
      }
    };

    document.addEventListener("click", handleAsyncClickOutsideDropdown);

    return () => {
      document.removeEventListener("click", handleAsyncClickOutsideDropdown);
    };
  }, []);

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(total / rowsPerPage);

  const handleEditEmail = (id, field, value) => {
    const index = emails.findIndex((obj) => obj.id === id);
    if (index !== -1) {
      const updatedEmails = [...emails];
      updatedEmails[index][field] = value;
      setEmails(updatedEmails);
    }
  };

  const handleRemoveEmail = (id) => {
    const filteredEmails = emails.filter((obj) => obj.id !== id);
    setEmails(filteredEmails);
  };

  const handleRemoveLatestEmail = () => {
    const updatedEmails = [...emails];
    const lastEmail = updatedEmails.pop();
    setEmails(updatedEmails);

    setEmail(lastEmail.email);
    setUserType(lastEmail.userType);
  };

  const handleRemoveResendEmail = (emailToRemove) => {
    const updatedEmails = alreadySentEmailsList.filter(
      (email) => email !== emailToRemove
    );
    setAlreadySentEmailsList(updatedEmails);
  };

  const handleOpenResendModal = () => {
    setIsResendModalOpen(true);
  };

  const handleCloseResendModal = () => {
    setIsResendModalOpen(false);
    setAlreadySentEmailsList([]);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEmails([]);
    setEmail("");
    setUserType("");
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    setIsBulkImportLoading(true);
    if (!bulkImportFile) {
      toast.error("Please select a file.", {
        position: "bottom-right",
        autoClose: 1500,
      });
      setIsBulkImportLoading(false);
      return;
    }
    const maxFileSize = 5 * 1024 * 1024;
    if (bulkImportFile.size > maxFileSize) {
      toast.error("File size exceeds the 5 MB limit.", {
        position: "bottom-right",
        autoClose: 1500,
      });
      setIsBulkImportLoading(false);
      return;
    }
    const fileExtension = bulkImportFile.name.split(".").pop();
    if (fileExtension !== "xlsx") {
      toast.error("Only xlsx files are supported.", {
        position: "bottom-right",
        autoClose: 1500,
      });
      setIsBulkImportLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", bulkImportFile);
    try {
      const response = await axios.post("/api/import/user", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === "requiredValidationError") {
        toast.error(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
        });
      } else {
        if (
          response.data.existingUserEmails &&
          response.data.existingUserEmails.length > 0
        ) {
          toast.error(
            `The following emails are already registered: ${response.data.existingUserEmails.join(", ")}`,
            {
              position: "bottom-right",
              autoClose: 5000,
            }
          );
          if (
            response.data.filteredUsers &&
            response.data.filteredUsers.length > 0
          ) {
            toast.success(
              `Inserted ${response.data.filteredUsers.length} records`,
              {
                position: "bottom-right",
                autoClose: 5000,
              }
            );
          }
        } else {
          toast.success("File uploaded successfully!", {
            position: "bottom-right",
            autoClose: 1500,
          });
        }
        refetchUserProfiles();
        handleBulkImportCloseModal();
      }
    } catch (error) {
      setComponentError(error);
      toast.error("Error uploading file. Please try again.", {
        position: "bottom-right",
        autoClose: 1500,
      });
      console.error(error);
      global.config?.slackMessage?.(error.toString?.());
    } finally {
      setIsBulkImportLoading(false);
    }
  };

  const handleBulkImportOpenModal = () => {
    setIsBulkImportModalOpen(true);
  };

  const handleBulkImportCloseModal = () => {
    setBulkImportFile(null);
    setBulkImportFileName("");
    setIsBulkImportModalOpen(false);
  };

  const handleBulkImportUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBulkImportFile(e.target.files[0]);
      setBulkImportFileName(file.name);
    } else {
      setBulkImportFile(null);
      setBulkImportFileName("");
    }
  };

  const filteredData = users.filter((item) => {
    const searchTerm = filter.trim().toLowerCase();
    const fullName =
      (item.first_name ||
        (item.company_first_name
          ? `${item.company_first_name} ${item.company_last_name ? item.company_last_name : ""
          }`
          : `${item.company_name} (Company)`)) +
      (item.middle_name && item.middle_name !== "null"
        ? " " + item.middle_name
        : "") +
      " " +
      item.last_name;

    const hasMatch =
      (fullName?.toLowerCase().includes(searchTerm) ||
        item.job_title?.toLowerCase().includes(searchTerm) ||
        item.email?.toLowerCase().includes(searchTerm) ||
        item.user_wx_comapny?.wx_company?.toLowerCase().includes(searchTerm)) &&
      (selectedStatus === "Active" ? item.is_active : true) &&
      (selectedStatus === "Inactive" ? !item.is_active : true);

    const isUserFilterMatched =
      userFilter === "All" || selectedTeams.includes(item._id);
    const isUserCategoryFilterMatched =
      userCategoryFilter === "All" ||
      selectedCategory.includes(item.user_category);
    const isAccountTypeFilterMatched =
      accountTypeFilter === "All" ||
      selectedAccountType.includes(item?.role_id?._id);

    if (user.role_id === userTypeName.Admin) {
      return (
        hasMatch &&
        item?.role_id?._id !== userTypeName.Super_Admin &&
        (item.user_category === userCategory.Individual ||
          item.user_category === userCategory.Business) &&
        isUserFilterMatched &&
        isUserCategoryFilterMatched &&
        isAccountTypeFilterMatched
      );
    }

    return (
      hasMatch &&
      (item.user_category === userCategory.Individual ||
        item.user_category === userCategory.Business) &&
      isUserFilterMatched &&
      isUserCategoryFilterMatched &&
      isAccountTypeFilterMatched
    );
  });

  const componentRef = useRef(null);
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.error("No data to export.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      // Set to current date and time: 06:05 PM IST, July 15, 2025
      const istDate = moment.tz("2025-07-15 18:05", "Asia/Kolkata");
      const istFormattedDate = istDate.format("YYYY-MM-DD");
      const istFormattedTime = istDate.format("HH:mm:ss");

      const modifiedLog = filteredData.map((item, index) => ({
        SlNo: index + 1,
        "User Name": item.first_name
          ? `${item.first_name} ${item.middle_name && item.middle_name !== "null"
            ? item.middle_name + " "
            : ""
          }${item.last_name}`
          : item.company_first_name
            ? `${item.company_first_name} ${item.company_last_name || ""}`
            : `${item.company_name || ""} (Company)`,
        Email: item.email,
        "Company Name": item.company_name,
        "User Category":
          item.user_category === userCategory.Individual
            ? "Individual"
            : item.user_category === userCategory.Business
              ? "Business"
              : item.user_category === userCategory.Vendor
                ? "Vendor"
                : item.user_category === userCategory.Client
                  ? "Client"
                  : "",
        Company: item?.user_wx_comapny?.wx_company
          ? item.user_wx_comapny.wx_company
          : "",
        Role: item.role_id?.user_type,
        "Job Title": item.job_title,
        Department: item?.department?.user_department,
        "Date of Birth": item?.dob
          ? moment(item.dob)
            .tz(global.config.getTimeZone())
            .format("DD/MM/YYYY")
          : "",
        "Passport Number": item.passport_no,
        "Registration Number": item.register_number,
        Mobile: item.mobile_no,
        Address: item.address,
        Pincode: item.pincode,
        Country: item.country,
        State: item.state,
        City: item.city,
        Currency: item.payment_currency,
        "Type of contract": item.typeOfContract
          ? item.typeOfContract.typeOfContract
          : " ",
        "Monthly Hours": `${item.monthly_hours || 168} hrs`,
        Compensation: item.cost
          ? item.cost.toLocaleString("en-US", {
            style: "currency",
            currency: item.payment_currency || "USD",
          })
          : new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: item.payment_currency || "USD",
          }).format(0),
        "Overhead Cost per Hour": item.overhead_cost
          ? item.overhead_cost.toLocaleString("en-US", {
            style: "currency",
            currency: item.payment_currency || "USD",
          })
          : new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: item.payment_currency || "USD",
          }).format(0),
        "VAT (%)": `${item.vat} %`,
        "Vat Id": item.vat_number ? item.vat_number : " ",
        "Is Client Active": item.is_active ? "Yes" : "No",
        "Created at": moment(parseInt(item.created_at)).format(
          "DD/MM/YYYY, hh:mm:ss A"
        ),
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);

      const getMaxLength = (arr, field) =>
        Math.max(
          ...arr.map((item) => (item[field] || "").toString().length),
          field.length
        );

      const headers = Object.keys(modifiedLog[0]);
      const colWidths = headers.map((header) => ({
        wch: getMaxLength(modifiedLog, header) + 5,
      }));

      worksheet["!cols"] = colWidths;

      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < headers.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center";
        style.alignment.vertical = "center";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }

      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }

      const fileName = `Users_${istFormattedDate}_${istFormattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clients Log");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "Clients Log",
        "Error occurred while exporting to Excel"
      );
      alert("Error occurred while exporting to Excel.");
    }
  };

  const [refetchLoading, setRefetchLoading] = useState(false);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (componentError) {
    return <ErrorBoundary error={componentError} />;
  }

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.3 }}
    >
      <div className="user-outer-overview invoice-outer-invoice">
        <div className="invoice-top">
          <div className="new-top-flter">
            <div className="button-sec-invoice">
              <Link to="/user/register">
                <span className="icon-invoice">
                  <img
                    src={UserIcon}
                    alt="Create Invoice"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/uploads/lowProfileImage/user_default.png";
                    }}
                  />
                </span>
                Create User
              </Link>
              <a className="btn-forpop-initem" onClick={handleOpenModal}>
                <span className="icon-invoice">
                  <img src={InviteIcon} alt="Export" />
                </span>
                Invite Users
              </a>

              <Modal
                isOpen={isModalOpen}
                onRequestClose={!isMailLoading ? handleCloseModal : undefined}
                contentLabel="Invite a User"
                className="user-invite-modal-main-outer"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-25%, -50%)",
                  },
                }}
              >
                <InviteUser
                  emails={emails}
                  handleAddEmail={handleAddEmail}
                  handleEditEmail={handleEditEmail}
                  handleSubmit={handleSubmit}
                  handleCloseModal={handleCloseModal}
                  isMailLoading={isMailLoading}
                  pendingInvitesCountLoading={pendingInvitesCountLoading}
                  userPendingInvitesCount={userPendingInvitesCount}
                  navigate={navigate}
                  roleId={roleId}
                  roleDropdownOpen={roleDropdownOpen}
                  setRoleDropdownOpen={setRoleDropdownOpen}
                  handleToggleRoleDropdown={handleToggleRoleDropdown}
                  roleDropdownRef={roleDropdownRef}
                  userTypeDropdownOpen={userTypeDropdownOpen}
                  handleToggleUserTypeDropdown={handleToggleUserTypeDropdown}
                  userTypeDropdownRef={userTypeDropdownRef}
                  userType={userType}
                  handleUserTypeOptionClick={handleUserTypeOptionClick}
                  email={email}
                  setEmail={setEmail}
                  emailValidation={emailValidation}
                  setEmailValodation={setEmailValodation}
                  selectValidation={selectValidation}
                  dletImage={dletImage}
                  addicon={addicon}
                  handleRemoveEmail={handleRemoveEmail}
                  handleRemoveLatestEmail={handleRemoveLatestEmail}
                  ThreeDots={ThreeDots}
                />
              </Modal>

              <Modal
                isOpen={isResendModalOpen}
                onRequestClose={
                  !isMailLoading ? handleCloseResendModal : undefined
                }
                contentLabel="Resend Invitations"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-25%, -50%)",
                  },
                }}
              >
                <ResentInvitations
                  alreadySentEmailsList={alreadySentEmailsList}
                  handleRemoveResendEmail={handleRemoveResendEmail}
                  handleCloseResendModal={handleCloseResendModal}
                  handleResendEmails={handleResendEmails}
                  isMailLoading={isMailLoading}
                  roleId={roleId}
                  crssrImage={crssrImage}
                  dletImage={dletImage}
                  ThreeDots={ThreeDots}
                />
              </Modal>

              <a
                className="btn-forpop-initem bulk-import"
                onClick={handleBulkImportOpenModal}
              >
                <span className="icon-invoice">
                  <img src={DownloadImage} alt="Export" />
                </span>
                Bulk Import
              </a>

              <a
                className="btn-forpop-initem bulk-export"
                onClick={exportToExcel}
              >
                <span className="icon-invoice">
                  <img src={DownloadImage} alt="Export" />
                </span>
                Export Data
              </a>

              <Modal
                isOpen={isBulkImportModalOpen}
                onRequestClose={
                  !isBulkImportLoading ? handleBulkImportCloseModal : undefined
                }
                contentLabel="Invite a User"
                className="bulk-import-popup"
                style={{
                  content: {
                    height: "50%",
                    width: "50%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-17.5%, -46%)",
                  },
                }}
              >
                <div className="modal">
                  <div className="outter-modal-main">
                    <a
                      className="close-image-clr1"
                      onClick={handleBulkImportCloseModal}
                      disabled={isBulkImportLoading}
                    >
                      <img src={crssrImage} alt="Close Bulk Import" />{" "}
                    </a>
                  </div>
                  <div className="outter-modal-main">
                    <p>Bulk Import</p>
                    <form>
                      <div className="relative w-full mb-3">
                        <label className="gray-label">Select client list</label>
                        <div className="file-input-wrapper">
                          <input
                            type="text"
                            className="form-input form-input-file"
                            value={bulkImportFileName}
                            readOnly
                          />
                          <input
                            type="file"
                            id="expFileAttchEdit"
                            name="expFileAttchEdit"
                            className="form-input hidden-input"
                            onChange={handleBulkImportUpload}
                          />
                          <label
                            htmlFor="expFileAttch"
                            className="file-input-label"
                          >
                            <img src={Plus} alt="Browse" />
                            Browse
                          </label>
                        </div>
                        <div className="text-sm bulk-text">
                          Demo File: {"    "}
                          <a
                            href="https://docs.google.com/spreadsheets/d/1rCCZmtrRoUs2wL-58OzTunfEYZdiVRQnvKYrTYQIhoQ/edit?usp=sharing"
                            className="form-textarea"
                            target="_blank"
                          >
                            Import_demo.xlsx
                          </a>
                        </div>
                      </div>

                      <div className="bulk-btn-section sprint-btn-outer">
                        <button
                          className="submit-client cancel-sprint"
                          type="button"
                          onClick={handleBulkImportCloseModal}
                          disabled={isBulkImportLoading}
                        >
                          Close
                        </button>
                        <button
                          className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded-full shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          type="button"
                          onClick={handleUpload}
                          disabled={isBulkImportLoading}
                        >
                          Send
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal>
            </div>
            <div className="search-sec search-sec-user-overview">
              <div className="search-container">
                <input
                  type="text"
                  onChange={(e) => {
                    setSearchFilter(e.target.value);
                    setDebouncedValue(e.target.value);
                    setCurrentPage(1);
                  }}
                  value={searchFilter}
                  className="search-input"
                  placeholder="Search"
                />
              </div>
            </div>
          </div>

          <Filters
            selectedTeams={selectedTeams}
            userProfiles={userProfiles}
            teamDropdownRef={teamDropdownRef}
            toggleTeamDropdown={toggleTeamDropdown}
            TruncateFilterFieldView={TruncateFilterFieldView}
            isTeamDropdownOpen={isTeamDropdownOpen}
            userSearchTerm={userSearchTerm}
            handleUserSearchChange={handleUserSearchChange}
            filteredUsers={filteredUsers}
            selectAllTeam={selectAllTeam}
            handleSelectAllTeamChange={handleSelectAllTeamChange}
            handleCheckboxTeamChange={handleCheckboxTeamChange}

            userCategoryDropdownRef={userCategoryDropdownRef}
            toggleCategoryDropdown={toggleCategoryDropdown}
            selectedCategory={selectedCategory}
            userCategoryList={userCategoryList}
            isCategoryDropdownOpen={isCategoryDropdownOpen}
            userCategorySearchTerm={userCategorySearchTerm}
            handleUserCategorySearchChange={handleUserCategorySearchChange}
            filteredUserCategoryList={filteredUserCategoryList}
            selectAllCategory={selectAllCategory}
            handleSelectAllCategoryChange={handleSelectAllCategoryChange}
            handleCheckboxCategoryChange={handleCheckboxCategoryChange}

            accountTypeDropdownRef={accountTypeDropdownRef}
            toggleAccountTypeDropdown={toggleAccountTypeDropdown}
            selectedAccountType={selectedAccountType}
            filteredRoleId={filteredRoleId}
            isAccountTypeDropdownOpen={isAccountTypeDropdownOpen}
            roleIdSearchTerm={roleIdSearchTerm}
            handleRoleIdSearchChange={handleRoleIdSearchChange}
            filteredRoleIdList={filteredRoleIdList}
            selectAllAccountType={selectAllAccountType}
            handleSelectAllAccountTypeChange={handleSelectAllAccountTypeChange}
            handleCheckboxAccountTypeChange={handleCheckboxAccountTypeChange}

            statusDropdownRef={statusDropdownRef}
            toggleStatusDropdown={toggleStatusDropdown}
            selectedStatus={selectedStatus}
            appSettings={appSettings}
            statusDropdownOpen={statusDropdownOpen}
            selectStatusOption={selectStatusOption}

            toggleFilterModal={toggleFilterModal}
            Modal={Modal}
            showFilterModal={showFilterModal}
            checkAndShowConfirmationModal={checkAndShowConfirmationModal}

            userCategoryModalDropdownRef={userCategoryModalDropdownRef}
            accountTypeModalDropdownRef={accountTypeModalDropdownRef}
            toggleAccountTypeModalDropdown={toggleAccountTypeModalDropdown}
            isAccountTypeModalDropdownOpen={isAccountTypeModalDropdownOpen}
            teamModalDropdownRef={teamModalDropdownRef}
            toggleTeamModalDropdown={toggleTeamModalDropdown}
            isTeamModalDropdownOpen={isTeamModalDropdownOpen}
            isCategoryModalDropdownOpen={isCategoryModalDropdownOpen}
            statusModalDropdownRef={statusModalDropdownRef}
            toggleStatusModalDropdown={toggleStatusModalDropdown}
            toggleCategoryModalDropdown={toggleCategoryModalDropdown}
            statusModalDropdownOpen={statusModalDropdownOpen}

            showConfirmationModal={showConfirmationModal}
            handleCancel={handleCancel}
            handleApplyConfirm={handleApplyConfirm}
            clearFilters={clearFilters}
            applyFilters={applyFilters}
          />

          <div className="filter-invoice-right">
            <div className="filter-inner showing-result">
              <label>Showing</label>
              <div
                ref={showingDropdownRef}
                className="select-modal-mainM custom-dropdown-user-new-outer"
              >
                <div
                  className="selected-option custom-dropdown-user-new"
                  onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}
                >
                  {total < 10 ? total.toString() : rowsPerPage.toString()}
                </div>
                {showingDropdownOpen && (
                  <div className="custom-dropdown-new">
                    <ul className="showing-options-list">
                      {total >= 10 && (
                        <li
                          className={rowsPerPage === 10 ? "selected-item" : ""}
                          onClick={() => {
                            handleRowsPerPageChange({ target: { value: 10 } });
                            setShowingDropdownOpen(false);
                          }}
                        >
                          10
                        </li>
                      )}
                      {total >= 20 && (
                        <li
                          className={rowsPerPage === 20 ? "selected-item" : ""}
                          onClick={() => {
                            handleRowsPerPageChange({ target: { value: 20 } });
                            setShowingDropdownOpen(false);
                          }}
                        >
                          20
                        </li>
                      )}
                      {total >= 30 && (
                        <li
                          className={rowsPerPage === 30 ? "selected-item" : ""}
                          onClick={() => {
                            handleRowsPerPageChange({ target: { value: 30 } });
                            setShowingDropdownOpen(false);
                          }}
                        >
                          30
                        </li>
                      )}
                      {total >= 40 && (
                        <li
                          className={rowsPerPage === 40 ? "selected-item" : ""}
                          onClick={() => {
                            handleRowsPerPageChange({ target: { value: 40 } });
                            setShowingDropdownOpen(false);
                          }}
                        >
                          40
                        </li>
                      )}
                      {total > 10 && (
                        <li
                          className={total > 10 && rowsPerPage === total ? "selected-item" : ""}
                          onClick={() => {
                            handleRowsPerPageChange({ target: { value: total }, });
                            setShowingDropdownOpen(false);
                          }}
                        >
                          ALL
                        </li>
                      )}
                      {total < 10 ? (
                        <li
                          className={total < 10 ? "selected-item" : ""}
                          onClick={() => {
                            handleRowsPerPageChange({ target: { value: total }, });
                            setShowingDropdownOpen(false);
                          }}
                        >
                          {total}
                        </li>
                      ) : null}
                    </ul>
                  </div>
                )}
              </div>
              <label>of {total} Results</label>
            </div>
          </div>
        </div>

        <RecentUsers
          wiseBanks={wiseBanks}
          wiseBanksLoading={wiseBanksLoading}
          wiseBanksError={wiseBanksError}
          paginatedTeams={paginatedTeams}
          isUpdating={isUpdating}
          RenderUserCTA={RenderUserCTA}
          renderUserStatus={renderUserStatus}
          UseRenderMemberName={UseRenderMemberName}
          BankAccountVerification={BankAccountVerification}
          RotatingLines={RotatingLines}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
        />
      </div>
    </motion.div>
  );
};
export default Users;